var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("footer-navigation", {
        attrs: { "current-page": _vm.Resources.Layout.MarketingServicesLink },
      }),
      _vm._v(" "),
      _c("base-hero", {
        attrs: {
          title: `${_vm.platformName} marketing services`,
          type: "marketing",
        },
        scopedSlots: _vm._u([
          {
            key: "description",
            fn: function () {
              return [
                _c(
                  "div",
                  { staticClass: "gfu-become-creator-hero__content _mb-6" },
                  [
                    _vm._v(
                      "\n                Boost your project's reach with our expert team.\n                We'll manage your promotion across Facebook, Instagram, Messenger and more...\n                From preview to pledge manager.\n            "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "external-link",
                  {
                    staticClass:
                      "gfu-btn gfu-btn--accent gfu-btn--soft gfu-btn--wide _tac",
                    attrs: { href: _vm.formUrl },
                  },
                  [
                    _vm._v(
                      "\n                Contact our experts\n            "
                    ),
                  ]
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c(
        "main",
        {
          staticClass:
            "gfu-layout-wrapper gfu-layout-wrapper--narrow _py-6 _flexcol _gap-6 js-main-content",
        },
        [
          _c(
            "div",
            [
              _c("base-title", { attrs: { level: "h2" } }, [
                _vm._v("Marketing services"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "gfu-bt gfu-bt--b1" }, [
                _vm._v("Why partner with us"),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c("marketing-services-values", {
            attrs: { "marketing-services-values": _vm.marketingServicesValues },
          }),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("base-title", { attrs: { level: "h2" } }, [
                _vm._v("They trusted us"),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "_grid _grid-cols-1 _grid-cols-2--m _gap-6" },
            _vm._l(_vm.trustedUs, function (item) {
              return _c(
                "div",
                {
                  key: item.title,
                  staticClass: "_pa-6 _aspect-square _rounded--common _ov-h",
                  style: item.styles,
                },
                [
                  _c(
                    "base-title",
                    { staticClass: "_tc--inherit", attrs: { level: "h1" } },
                    [_vm._v(_vm._s(item.title))]
                  ),
                  _vm._v(" "),
                  _c("div", [_vm._v(_vm._s(item.description))]),
                ],
                1
              )
            }),
            0
          ),
          _vm._v(" "),
          _c("base-title", { attrs: { level: "h2" } }, [_vm._v("Reach out")]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "gfu-box gfu-box--flat gfu-box--huge gfu-bt gfu-bt--b1 _tac",
            },
            [
              _c("base-icon", {
                staticClass: "_tc--accent _mb-6",
                attrs: { name: "envelope", size: "4x" },
              }),
              _vm._v(" "),
              _c("div", [_vm._v("Request support to grow your audience.")]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "_mt-6" },
                [
                  _c(
                    "external-link",
                    {
                      staticClass:
                        "gfu-btn gfu-btn--primary gfu-btn--soft gfu-btn--wide _tac",
                      attrs: { href: _vm.formUrl },
                    },
                    [
                      _vm._v(
                        "\n                    Complete the form\n                "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }